/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
$(document).ready(function(){
  $('.header_support_button').click(function(){
    $(this).closest('.header__action-item--support').toggleClass('open');
  });
  
  $(document).on('click', function(event) {
    let $targetDiv = $('#header_custom_support_wrapper'); 
    if (!$targetDiv.is(event.target) && $targetDiv.has(event.target).length === 0) {      
      $('.header__action-item.header__action-item--support').removeClass('open');
    }
  });
  
});

/* Clyra 28 Sept: variants not sold online show a "Contact the team" link to /pages/contact
   instead of a disabled button. Swaps the two on every variant change.
   Clyra 28 Sept (tidy): also hides the quantity selector and the pick-up notice
   (.rf-sellable-only) when the selected variant isn't sold online. */
(function () {
  function rfContactToggle(available) {
    document.querySelectorAll('.product-form__buy-buttons').forEach(function (wrap) {
      var btn = wrap.querySelector('.product-form__add-button');
      var link = wrap.querySelector('.rf-contact-team');
      if (!btn || !link) return;
      btn.style.display = available ? '' : 'none';
      link.style.display = available ? 'none' : '';
    });
    document.querySelectorAll('.product-form .rf-sellable-only').forEach(function (el) {
      el.style.display = available ? '' : 'none';
    });
  }
  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail && event.detail.variant;
    var available = !!(variant && variant.available);
    setTimeout(function () { rfContactToggle(available); }, 0);
  });
})();
